import { styled, TableRow } from '@mui/material';

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  padding: 0,
  border: `1px solid ${theme.palette.grey[300]}`,
}));
